import { environmentHttpClient } from "client/Api/httpClient";

export type LiquitConnectionInformationModel = {
	portalUrl: string;
	identitySource: string;
	accessToken: string;
	userPrincipalName: string;
};

export function getConnectionInformation(
	connectionId: number,
	signal?: AbortSignal
): Promise<LiquitConnectionInformationModel> {
	return environmentHttpClient.get<LiquitConnectionInformationModel>(
		`Workspace/LiveInformation/Liquit/Connections/${connectionId}`,
		undefined,
		{ signal }
	);
}